import { useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";

import { Team, TeamAttributes } from "~/api/Api";
import { apiClient } from "~/api/ApiClient";
import FormLabel from "~/components/login/formLabel/FormLabel";
import Input from "~/components/ui/input/Input";
import Modal from "~/components/ui/modal/Modal";
import labels from "~/helpers/labels";
import { tryCatch } from "~/helpers/tryCatch";

import styles from "./CreateNewTeamModal.module.scss";

export const CreateNewTeamModal = ({
  isOpen,
  closeModal,
  onTeamCreated,
}: {
  isOpen: boolean;
  onTeamCreated: (team: Team) => void;
  closeModal: () => void;
}) => {
  const { mutateAsync } = useMutation({
    mutationFn: (data: TeamAttributes) => {
      return apiClient.teams.teamsCreate(data);
    },
  });

  const form = useForm<TeamAttributes>();

  const {
    register,
    handleSubmit,
    reset: resetForm,
    formState: { errors, isSubmitting },
  } = form;

  return (
    <Modal
      modalLabel={<h3>Create new team</h3>}
      buttonLabel="Create"
      formId="create-team-form"
      isOpen={isOpen}
      closeModal={closeModal}
      isLoading={isSubmitting}
      onTransitionExited={() => {
        resetForm();
      }}
    >
      <form
        className={styles.createTeamForm}
        id="create-team-form"
        onSubmit={handleSubmit(async (data) => {
          const result = await tryCatch(mutateAsync(data));

          if (result.error) {
            return { error: result.error };
          }

          onTeamCreated(result.data.data.team);

          closeModal();
        })}
      >
        <div>
          <FormLabel label="Name" />
          <Input
            disabled={isSubmitting}
            errormessage={
              errors.name
                ? errors.name.message || labels.THIS_FIELD_CANNOT_BE_EMPTY
                : ""
            }
            {...register("name", {
              required: true,
            })}
            placeholder="Enter team name"
          />
        </div>
      </form>
    </Modal>
  );
};
